import React from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import Sidebar from "../../../../shared/components/layout/Sidebar";
import { AnalyticsProvider } from "../context/AnalyticsContext";
import { PinnedBoardsProvider } from "../context/PinnedBoardsContext";

function AnalyticsLayoutInner() {
  const { team } = useParams();

  if (!team) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PinnedBoardsProvider teamId={team}>
    <div className="flex h-screen overflow-hidden" style={{ backgroundColor: "#ffffff" }}>
      <Sidebar
        isOpen={true}
        onClose={() => {}}
        onNavigate={() => {}}
        hideMarketing={() => {}}
        isCompact={false}
        currentPage="analytics"
      />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Outlet />
      </div>
    </div>
    </PinnedBoardsProvider>
  );
}

export default function AnalyticsLayout() {
  return (
    <AnalyticsProvider>
      <AnalyticsLayoutInner />
    </AnalyticsProvider>
  );
}
